export default __webpack_public_path__ + "static/media/ELEMENTOS_13.aba1403e.png";